module.exports = __webpack_public_path__ + "img/123.8.db565ec0.png";